<template>
  <div>
    <h2>Umræðuefni {{ episode_nr }} þáttar</h2>
    <div class="mynd">
      <fire-image :refName="'episode-'+ episode_nr +'.jpg'"/>
    </div>

    <div class="player" v-if="podcastUrl">
      <audio controls v-on:ended="goToNext" :autoplay="autoPlay">
        <source :src="podcastUrl" type="audio/mpeg">
        Your browser does not support the audio tag.
      </audio>
    </div>

    <article v-for="(topic, idx) in episodeTopics" :key="idx">
      <h1 v-if="topic.isFromStreet">– Málefni úr sal –</h1>
      <topic :topicObj="topic"/>
    </article>

    <main-footer/>
  </div>
</template>

<script>
import {db} from '../main'
import Topic from './Topic.vue'
import FireImage from './FireImage.vue';
import MainFooter from './MainFooter.vue';
import {enhanceTopicsWithFeedData} from '../utils';
import store from '../store';

export default {
  name: 'Episode',
  components: {
    MainFooter,
    FireImage,
    Topic
  },
  data() {
    return {
      topics: [],
      episode_nr: this.$route.params.episode_nr,
      autoPlay: this.$route.query.autoPlay === 'true',
      podcastUrl: undefined,
    }
  },
  firestore() {
    return {
      topics: db.collection('topics').where('episode_nr', '==', this.episode_nr).orderBy('order_by')
    }
  },
  computed: {
    episodeTopics() {
      const enhancedTopics = enhanceTopicsWithFeedData(this.topics, store.state.rssFeed);
      this.podcastUrl = enhancedTopics.length > 0 && enhancedTopics[0].enclosure ? enhancedTopics[0].enclosure.attr_url : undefined;
      return enhancedTopics.filter(t => t.episode_nr === this.episode_nr);
    }
  },
  methods: {
    goToNext(e) {
      const nextEpisode = +this.episode_nr + 1;
      this.$router.replace(`/episode/${nextEpisode}?autoPlay=true`);
    }
  }
}
</script>

<style scoped>
.mynd img {
  width: 33%;
}

@media (max-width: 780px) {
  .mynd img {
    width: 100%;
  }
}

footer {
  margin-bottom: 30px;

}

footer.menu {
  font-size: 0.8em;
}

footer.menu hr {
  font-size: 0.8em;
  margin-top: 30px;
  margin-bottom: 30px;
}

footer.menu a {
  border: 1px solid white;
  padding: 5px 10px;
  margin-right: 15px;
}

.player audio{
  width: 95%;
}

</style>



// WEBPACK FOOTER //
// src/components/Episode.vue